import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { defaultThemeProp, tryCatch } from '@pega/cosmos-react-core';
import type { WithAttributes } from '@pega/cosmos-react-core';

const StyledBlockQuote = styled.blockquote(
  ({ theme }) => css`
    color: ${tryCatch(() =>
      rgba(theme.base.palette['foreground-color'], theme.base.transparency['transparent-2'])
    )};
    border-inline-start: solid 0.0625rem ${theme.base.palette['border-line']};
    padding-inline-start: ${theme.base.spacing};
    padding-block: ${theme.base.spacing};
    margin-inline-start: ${theme.base.spacing};
    margin-block: ${theme.base.spacing};
  `
);

StyledBlockQuote.defaultProps = defaultThemeProp;

type BlockQuoteProps = WithAttributes<
  'blockquote',
  {
    children: ReactNode;
  }
>;

const BlockQuote = ({ children, ...restProps }: BlockQuoteProps) => {
  return <StyledBlockQuote {...restProps}>{children}</StyledBlockQuote>;
};

export default BlockQuote;
